import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"
import api from "../../services/api"
import Loader from "react-loader-spinner";
import CsvDownload from 'react-json-to-csv'


class MatriculasnaopagasAdmin extends Component {


  state = {
    matriculas:[],
    search:null,

    loaded:false,

    downloadmat:[]
  }

  
  async componentDidMount(){
    const {search} = this.state;
    const response = await api.post("/admin/matriculas/paid", {search});

    if(response.data){
      this.setState({
        matriculas:response.data,
        loaded:true
      })
    }

    let downloadmat=[];
    response.data.forEach(matricula => {
      let temp=[];
      temp["nome"]=matricula.user.dados_users.nomecompleto;
      temp["telefone"]=matricula.user.dados_users.telefone1;
      temp["curso"]=matricula.pos_curso.nome;
      temp["data_inscricao"]=matricula.created_at
      temp["mensalidadestotal"]=matricula.qtdparcelas
      temp["mensalidade pagas"]=matricula.qtdparcelas_pagas
      temp["mensalidade não pagas"]=matricula.qtdparcelas_unpagas

      downloadmat.push(temp)
      
    });

   
    this.setState({
      downloadmat:downloadmat
    })


  }

  async shouldComponentUpdate(nextProps, nextState){

    if(this.state.search!==nextState.search){
      nextState.matriculas=[];
      const {search} = nextState;
      const response = await api.post("/admin/matriculas/paid", {search});
  
      this.setState({
        matriculas:response.data,
        loaded:true
      })

      this.forceUpdate();
    }

    return true;
  }



  render() {
    
  
    return (
      
      <React.Fragment>
          <Header />
          
        <div class="container col-lg-11 p-4">     

    
<h4>Matriculas Pagas</h4>
<CsvDownload children="Extrair Matriculas" class="btn btn-dark" 
disabled={this.state.btn==true} 
filename={"matriculas_faturas_naopaga_olgamettig"+new Date().getDate()+'-'+new Date().getMonth()+'-'+new Date().getFullYear()+".csv"} 
data={this.state.downloadmat} />

 {/* Tables */}
<br></br>
 <input type="text" id="myInput" onChange={e => this.setState({ search: e.target.value, loaded:false })}  placeholder="Nome Aluno, CPF, ID User" />
 <button type="button" class="btn btn-light btn-sm">Pesquisar</button>

 <table class="table">
  <thead>
  <tr>
      <th class="th-sm">Nº Pedido

    </th>
      <th class="th-sm">Nome Aluno

    </th>
    <th class="th-sm">Telefone

      </th>
    <th class="th-sm">Indicação

    </th>
      <th class="th-sm">Nome Curso

      </th>
      <th class="th-sm">Modalidade

      </th>
      <th class="th-sm">Data Inscrição

      </th>
      <th class="th-sm">Inscrição

      </th>


      <th class="th-sm">Pagamento

      </th>
      <th class="th-sm">Status

      </th>
      <th class="th-sm">Ação

      </th>


    </tr>
  </thead>
  <tbody>
  {this.state.matriculas.map(el => (
    <tr>
    <td>{el.orderid}</td>
    <td>{el.user.dados_users.nomecompleto}</td>
    <td>{el.user.dados_users.telefone1}</td>
    <td>{el.indicacao}</td>
    <td>{el.pos_curso.nome}</td>
    <td>{el.isead==true?"EAD":"Presencial"}</td>
    <td>{el.created_at}
    </td>
    <td>{el.price}</td>
     { el.paid==1 && <td>Pago</td>}
     { el.paid==0 && <td>Não Pago</td>}


     { el.status==0 && <td>Pendente</td>}
     { el.status==1 && <td>Ativa</td>}
     { el.status==2 && <td>Cancelada</td>}
     { el.status==3 && <td>Matriculado</td>}
     { el.status==4 && <td>Concluída</td>}
     { el.status==5 && <td>Concluída com Pendência</td>}
     { el.status==6 && <td>Formado</td>}
     { el.status==7 && <td>Ativa Totalmente Paga</td>}
    
    <td>
    
    <a href={"/admin/faturas/"+el.id} class="btn btn-info btn-sm">Faturas</a>
        <a href={"/admin/matricula/edit/"+el.id} class="btn btn-secondary btn-sm">Editar</a>
        <a href={"/admin/matricula/remove/"+el.id} class="btn btn-danger btn-sm">Remover</a>
    </td>
  </tr>
  ))}
    

  </tbody>
</table>
<Loader
    className="d-flex justify-content-center"
    type="TailSpin"
    color="#00BFFF"
    height={100}
    width={100}
    visible={this.state.loaded==false} //3 secs
    />
{/* FIm table */}












    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(MatriculasnaopagasAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/matriculaspagas.js